/* eslint-disable */

import React, { useState, useEffect } from 'react';
import error from '../autorizacaoGuias/images/archive.png'
import ExtratoCoparticipacoesService from '../../../../services/extratoCoparticipacoesService'
import InputMask from 'react-input-mask';
import moment from 'moment';
import erroImg from './erro.png'

export default (props) => {
    const [exibirAuth, setExibirAuth] = useState(false);
    const [exibirCopart, setExibirCopart] = useState(false);
    const [erroApi, setErroApi] = useState(false);
    const [mensagem, setMensagem] = useState("")
    const [loading, setLoading] = useState(false)
    const [didError, setDidError] = useState(false)
    const [errorsForm, setErrorsForm] = useState([])
    const [success, setSuccess] = useState(false)
    const [response, setResponse] = useState({})

    const [dataNascimento, setDataNascimento] = useState("")
    const [carteiraCpf, setCarteiraCpf] = useState("")
    const [nomeMae, setNomeMae] = useState("")
    const [maeDesconhecida, setMaeDesconhecida] = useState(false)

    const renderValidation = (field) => {
        const error = errorsForm.filter(e => e.field === field)
        if (!error.length) {
            return null
        }
        return (<div className="validation-message" style={{padding:"1.0rem"}}>{error[0].message}</div>)
    }

    const renderSuccess = () => {
        if (success) {
            return <div className="success"><p>Solicitação enviada com sucesso</p></div>
        }

    }

    const renderError = () => {
        if (didError) {
            return (
                <div className="not-found-wrapper">
                    <img src={error} alt="Erro" />
                    <h5>Ocorreu um erro</h5>
                    <p>
                        Um erro ocorreu ao processar sua consulta. Por favor tente
                        novamente.
              </p>
                    <p>
                        Se esta mensagem for recorrente, entre em contato com o suporte.
              </p>
                </div>
            );
        }
        return null;
    };

    const sendData = async () => {
        setResponse({})
        setErroApi(false);
        let dataNascimentoFormatada = moment(dataNascimento).format('DD/MM/YYYY');
        let carteiraCpfLimpo = carteiraCpf.replace(/\D/g, '');

        let dados = {
            "cpf": carteiraCpfLimpo.length == 11 ? carteiraCpfLimpo : "",
            "carteira": carteiraCpfLimpo.length == 17 ? carteiraCpfLimpo : "",
            "dataNascimento": dataNascimentoFormatada,
            "nomeMae": nomeMae,
            "maeDesconhecida": maeDesconhecida
        };

        const errors = []
        if (validateForm()) {
            return;
        }

        setLoading(true);
        const res = await ExtratoCoparticipacoesService.getCoparticipacoes(dados);
        setLoading(false);

        if (res.status) {
            setExibirAuth(false);
            setExibirCopart(true);
            setResponse(res)
        } else {            
            setErroApi(true);
            errors.push({ field: 'autenticacao', message: res.info });
        }

        setErrorsForm(errors);
    }

    const validateForm = () => {
        const errors = []

        if (dataNascimento.length < 10) {
            errors.push({ field: "dataNascimento", message: "Preencha sa data de nascimento" })
        }

        if (carteiraCpf.length < 11) {
            errors.push({ field: "carteiraCpf", message: "Preencha o número da carteira ou cpf" })
        }

        if (!maeDesconhecida && nomeMae === "") {
            errors.push({ field: "nomeMae", message: "Preencha o nome da mãe" })
        }
        setErrorsForm(errors)
        return errors.length
    }


    return (
        <section className={`txt8 lh-1`}>
            <h2 className="txt-laranja ">Extrato de coparticipações</h2>

            <div className="box-passos">
                <div>
                    {/* <div style={exibirAuth ? {} : { display: 'none' }}> */}
                    <div className="linha-form"><div>Carteira/CPF:</div><div> <input type="text" id="carteiraCpf" name="carteiraCpf" value={carteiraCpf} onChange={e => setCarteiraCpf(e.target.value)} /> {renderValidation("carteiraCpf")}</div></div>
                    <div className="linha-form"><div>Data Nascimento:</div><div> <input type="date" id="dataNascimento" name="dataNascimento" value={dataNascimento} onChange={e => setDataNascimento(e.target.value)} /> {renderValidation("dataNascimento")}</div></div>
                    <div className="linha-form"><div>Nome Mãe:</div><div> <input type="text" id="nomeMae" name="nomeMae" value={nomeMae} onChange={e => setNomeMae(e.target.value)} disabled={maeDesconhecida} /> {renderValidation("nomeMae")}</div></div>
                    <div className="linha-form"><div>Mãe Desconhecida:</div><div> <input type="checkbox" id="maeDesconhecida" name="maeDesconhecida" value={maeDesconhecida} onChange={e => setMaeDesconhecida(!maeDesconhecida)} /></div></div>
                    <div className="linha-form"><div></div><div><button disabled={success} className="btn" onClick={() => sendData()}>Consultar</button></div></div>
                    <div className="linha-form" style={{ justifyContent: "center", marginTop: "2.0rem" }}>
                        <div style={{ display: "flex", flexDirection: "row",alignItems:"center" }}>
                            <img style={erroApi ? {} : { display: 'none' }} src={erroImg} alt="Erro" width="100px" />
                            {renderValidation("autenticacao")}
                        </div>
                    </div>
                    {loading ?
                        <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
                        : null}
                    {renderError()}
                    {renderSuccess()}
                </div>
            </div>
            <p></p>
            <div className="box-passos" style={exibirCopart ? {} : { display: 'none', margin: '1.0rem 0rem 0rem 0rem' }}>
                <div style={exibirCopart ? {} : { display: 'none' }}>
                    <div>
                        {response.hasOwnProperty('eventos') ? response.eventos.length > 0 ? response.eventos.map((evento) => {

                            return (
                                <div>
                                    <span style={{ fontWeight: "bold", fontSize: "20px" }}>{evento.nome}</span><p />

                                    <div style={{ display: "flex", flexDirection: "row", textAlign: "left", borderBottom: "1px solid #d4d4d4", marginBottom: "1rem" }}>
                                        <div style={{ flex: 0.6 }}>
                                            <span>Fatura</span><p></p>
                                        </div>
                                        <div style={{ flex: 0.5 }}>
                                            <span>Vencimento</span><p></p>
                                        </div>
                                        <div style={{ flex: 0.5 }}>
                                            <span>Código</span><p></p>
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <span>Prestador</span><p></p>
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <span>Descrição</span><p></p>
                                        </div>
                                        <div style={{ flex: 0.5 }}>
                                            <span>Quantidade</span><p></p>
                                        </div>
                                        <div style={{ flex: 0.5 }}>
                                            <span>Data</span><p></p>
                                        </div>                                    
                                        <div style={{ flex: 1 }}>
                                            <span>Valor de coparticipação</span><p></p>
                                        </div>
                                        
                                    </div>
                                    {
                                        evento.coparts.map((copart) => {
                                            let data = copart.data !== "    -  -  T00:00:00"?moment(copart.data).format('DD/MM/YYYY'):'';
                                            console.log(data)
                                            console.log(copart.data)
                                            return (<div>
                                                <div style={{ display: "flex", flexDirection: "row", textAlign: "left" }}>
                                                    <div style={{ flex: 0.6 }}>
                                                        <span>{copart.titulo}</span>
                                                    </div>
                                                    <div style={{ flex: 0.5 }}>
                                                        <span>{copart.vencimento}</span>
                                                    </div>
                                                    <div style={{ flex: 0.5 }}>
                                                        <span>{copart.codigo}</span>
                                                    </div>
                                                    <div style={{ flex: 1 }}>
                                                        <span>{copart.prestador}</span>
                                                    </div>
                                                    <div style={{ flex: 1 }}>
                                                        <span>{copart.descricao}</span>
                                                    </div>
                                                    <div style={{ flex: 0.5 }}>
                                                        <span>{copart.qtd}unid.</span>
                                                    </div>
                                                    <div style={{ flex: 0.5 }}>
                                                        <span>{data}</span>
                                                    </div>                                                  
                                                    <div style={{ flex: 1 }}>
                                                        <span>{(copart.copart+copart.servico).toLocaleString('pt-BR', {
                                                            style: 'currency',
                                                            currency: 'BRL',
                                                        })}</span>
                                                    </div>
                                                   
                                                </div>
                                                <div style={{ width: "100%", borderTop: "1px solid #d4d4d4", margin: "2rem 0rem 1rem 0rem" }}></div>
                                            </div>)
                                        })
                                    }
                                </div>
                            )
                        }) : <div style={{ textAlign: "center" }}><span>Não existem coparticipações</span></div> : ""}
                    </div>

                </div>
            </div>

        </section>

    )
}